import { useEffect, useState } from "react";

/**
 * True when the viewport is at least `px` wide. Mirrors `useIsMobile`'s pattern
 * (initial read + matchMedia listener) so components can pick a layout by a
 * specific breakpoint — e.g. the Customers master-detail split at md (768px).
 */
export function useMinWidth(px: number): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= px,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${px}px)`);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [px]);

  return matches;
}
